var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock4Img1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 69,
    viewBox: "0 0 101 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_3291)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.362061 68.3383H22.0675L23.6179 49.7337L3.46284 45.0825L0.362061 68.3383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23804 41.9817L23.6179 46.6329L28.269 30.3538L11.99 21.8267L4.23804 41.9817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5403 18.7257L29.0442 27.2528L41.4473 18.7257L29.8194 5.54736L13.5403 18.7257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.362 68.3383H78.6566L77.1062 49.7337L97.2612 45.0825L100.362 68.3383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4861 41.9817L77.1062 46.6329L72.4551 30.3538L88.7341 21.8267L96.4861 41.9817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1838 18.7257L71.68 27.2528L59.2769 18.7257L70.9048 5.54736L87.1838 18.7257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6953 3.22187L45.3232 17.1754H56.1759L66.2535 3.22187L56.1759 0.121094H45.0519L33.6953 3.22187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.362061 68.3383H22.0675L23.6179 49.7337L3.46284 45.0825L0.362061 68.3383Z",
    fill: "#9A0700"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23804 41.9817L23.6179 46.6329L28.269 30.3538L11.99 21.8267L4.23804 41.9817Z",
    fill: "#B40E0F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5403 18.7257L29.0442 27.2528L41.4473 18.7257L29.8194 5.54736L13.5403 18.7257Z",
    fill: "#C01B1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.362 68.3383H78.6566L77.1062 49.7337L97.2612 45.0825L100.362 68.3383Z",
    fill: "#9A0700"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4861 41.9817L77.1062 46.6329L72.4551 30.3538L88.7341 21.8267L96.4861 41.9817Z",
    fill: "#B40E0F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1838 18.7257L71.68 27.2528L59.2769 18.7257L70.9048 5.54736L87.1838 18.7257Z",
    fill: "#C01B1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6953 3.22187L45.3232 17.1754H56.1759L66.2535 3.22187L56.1759 0.121094H45.0519L33.6953 3.22187Z",
    fill: "#C01B1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_3291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 68.2171,
    fill: "white",
    transform: "translate(0.362061 0.121094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock4Img1);
export default __webpack_public_path__ + "static/media/block_4_img_1.54720982bc32c92399f573f3dd79f324.svg";
export { ForwardRef as ReactComponent };